// Presentation and route bindings for screens that exist in this backoffice.
export const navigationRoutes = new Map([
  ['HOME', 'App.Home'],
  ['BUSINESS_DATA', 'App.Dashboard.MiNegocio'],
  ['COUPONS', 'App.Dashboard.Descuentos'],
  ['PROMOTIONS', 'App.Dashboard.Promociones'],
  ['GIFTCARDS', 'App.Dashboard.Certificados'],
  ['EVENTS', 'App.Events'],
  ['REDEMPTIONS', 'App.Dashboard.Canjes'],
  ['USERS_HISTORY', 'App.Settings.Users'],
  ['REPORTS_REDEMPTIONS', 'App.Dashboard.Reportes'],
  ['CONFIG_CATEGORIES', 'App.Settings.Catalogs.Category'],
])

export function navigationCodeForState(stateName) {
  for (const [code, route] of navigationRoutes) {
    if (stateName === route || stateName?.startsWith(`${route}.`)) return code
  }
  return null
}

export function getNavigationEntries(navigation) {
  const entries = new Map()
  const visit = (items) => {
    for (const item of items) {
      if (item.visibility === 'HIDDEN') continue
      entries.set(item.code, item)
      if (item.visibility === 'ENABLED') visit(item.children)
    }
  }
  for (const section of navigation?.sections || []) visit(section.items)
  return entries
}

export const canOpenNavigationEntry = (entry) => entry?.visibility === 'ENABLED' && !entry.children.length

export function firstNavigationRoute(navigation) {
  const entries = getNavigationEntries(navigation)
  if (canOpenNavigationEntry(entries.get('HOME'))) return navigationRoutes.get('HOME')
  for (const [code, entry] of entries) {
    if (canOpenNavigationEntry(entry) && navigationRoutes.has(code)) return navigationRoutes.get(code)
  }
  return 'App.Profile'
}
